import * as yup from 'yup';

export const dealInputSchema = yup.object().shape({
    dealTypeId: yup.number().required(),
    dealName: yup.string().required(),
    market_id: yup.string().required(),
    constructionTypeId: yup.string().required(),
    useCoordinates: yup.boolean().required(),
    latitude: yup.number().notRequired(),
    longitude: yup.number().notRequired(),
    address: yup.string().notRequired(),
    acquisitionPrice: yup.number().required(),
    city: yup.string().notRequired(),
    county: yup.string().notRequired(),
    state: yup.string().notRequired(),
    zipCode: yup.string().notRequired(),
});
